/* eslint-disable */
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    userListState: {},
    createRListUserdata: {},
    createUserdata: {},
    updateuserDetailsData: {},
    userDetailsDataByid: {},
    dahboardUserListState: {},
    userSubcriptionById: {},
    createSubscriptionData: {},
    rListUserState: {},
    updateRlistUserDetailsData: {},
    rlistUserDetailsDataByid: {},
    deleteRListUser: {},
    accountUserState:{},
    userPointsObtainedState:{},
    updateFlagUserDetailsData:{}
  },
  mutations: {
    updateFlagUserDetailsFun(state, response) {
      state.updateFlagUserDetailsData = response
    },
    updateRListUserDetailsFun(state, response) {
      state.updateRlistUserDetailsData = response
    },
    rListUserDetailsByid(state, response) {
      state.rlistUserDetailsDataByid = response
    },
    userListMutation(state, response) {
      state.userListState = response
    },
    rlistUserListMutation(state, response) {
      state.rListUserState = response
    },
    createUserMutation(state, response) {
      state.createUserdata = response
    },
    createRListUserMutation(state, response) {
      state.createRListUserdata = response
    },
    createSubscriptionMutation(state, response) {
      state.createSubscriptionData = response
    },
    updateUserDetailsFun(state, response) {
      state.updateuserDetailsData = response
    },
    userDetailsByid(state, response) {
      state.userDetailsDataByid = response
    },
    getUserSubcription(state, response) {
      state.userSubcriptionById = response
    },
    dashboardUserListMutation(state, response) {
      state.dahboardUserListState = response
    },
    deleteRListMutation(state, response) {
      state.deleteRListUser = response
    },
    accountUserMutation(state, response) {
      state.accountUserState = response
    },
    userPointsObtainedMutation(state, response) {
      state.userPointsObtainedState = response
    },
  },
  actions: {
    getUserPointsObtained(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/quizzes/admin/points_obtained/' + payload.id + '/').then((response) => {
            context.commit('userPointsObtainedMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getRlistUserList(context) {
      return new Promise((resolve, reject) => {
        axios.get('/account/rlist').then((response) => {
            context.commit('rlistUserListMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    createRListUserList(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/account/rlist/', payload).then((response) => {
            context.commit('createRListUserMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getRListUserListDetailsById(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/account/rlist/' + payload.id + '/').then((response) => {
            context.commit('rListUserDetailsByid', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    UpdateUserFlagStatusById(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + "/account/admin/update-user-flag/";
        let id = payload.data.id;
        let data = {
          is_flagged: payload.data.is_flagged,
          flag_remark: payload.data.flag_remark
        }
        axios.patch(url + id + '/', data).then((response) => {
            context.commit('updateFlagUserDetailsFun', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    UpdateRListUserDetailsById(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + "/account/rlist/";
        let id = payload.id;
        let data = {
          first_name: payload.first_name,
          last_name: payload.last_name,
          email: payload.email,
          mobile: payload.mobile,
          restrictions: payload.restrictions
        }
        axios.patch(url + id + '/', data).then((response) => {
            context.commit('updateRListUserDetailsFun', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    removeRListUser(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/account/rlist/' + payload.id + '/').then((response) => {
            context.commit('deleteRListMutation', response.data.data)
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    removeRListFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/api/account/delete_rlist/', payload).then((response) => {
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    getUserRoleDetails(context) {
      return new Promise((resolve, reject) => {
        axios.get('/account/user/').then((response) => {
           context.commit('accountUserMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getUserListDetails(context) {
      return new Promise((resolve, reject) => {
        axios.get('/account/admin/users/').then((response) => {
            context.commit('userListMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getUserListDetailsOfDashboard(context) {
      return new Promise((resolve, reject) => {
        axios.get('/account/admin/users/?order_by=-date_joined&page_size=5').then((response) => {
            context.commit('dashboardUserListMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getUserListDetailsById(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/account/admin/user/' + payload.id + '/').then((response) => {
            context.commit('userDetailsByid', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getUserSubscriptionById(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/payment/admin/subscription/user/' + payload.id + '/disable/').then((response) => {
            context.commit('getUserSubcription', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    UpdateUserDetailsById(context, payload) {
      return new Promise((resolve, reject) => {
        let url = baseURL + "/account/admin/user/";
        let id = payload.data.id;
        axios.patch(url + id + '/', payload.data.data).then((response) => {
            context.commit('updateUserDetailsFun', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    createUserList(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/account/admin/users/', payload).then((response) => {
            context.commit('createUserMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    createSubscription(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/payment/admin/subscription/user/', payload).then((response) => {
            context.commit('createSubscriptionMutation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getExportUserDetails (context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/account/exportusers/', payload).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    userAccountDelete(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/account/admin/user/' + payload.data.id + '/', payload.data).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
    getuserListDetailsState: state => state.userListState,
    createuserListDetailsState: state => state.createUserdata,
    updateUserDetailsState: state => state.updateuserDetailsData,
    getUserDetailsByIdState: state => state.userDetailsDataByid,
    getdahboardUserListState: state => state.dahboardUserListState,
    getrListuserDetailsState: state => state.rListUserState,
    getRListUserDetailsByIdState: state => state.rlistUserDetailsDataByid,
    accountUserGetters: state => state.accountUserState,
    userPointsObtainedGetters: state => state.userPointsObtainedState
  }
}
